import dayjs from 'dayjs';

// A dispatch day, as the floor actually runs it. The run sheet is printed at the
// end of it, so these are the defaults rather than an empty pair of pickers.
//
// Hours, not '09:00' strings: parsing a time string needs dayjs's
// customParseFormat plugin, which this app has never registered — dayjs('09:00',
// 'HH:mm') silently returns an Invalid Date rather than complaining.
export const RUN_SHEET_OPENS = 9;
export const RUN_SHEET_CLOSES = 18;

/** Today at a given hour, which is all the time pickers are ever seeded with. */
export const atHour = (hour) => dayjs().hour(hour).minute(0).second(0).millisecond(0);

/**
 * The chosen day and the chosen hours, folded into the window `/orders/runSheet`
 * takes.
 *
 * Its own module, away from the component, for the reason every other bit of
 * tested logic in this folder is: importing the component drags in the axios
 * client, and jest cannot load that. It is also the one piece of arithmetic here
 * that can be silently wrong — the pickers hand back three separate dayjs
 * objects, and only the date half of one and the clock half of the other two
 * matter.
 *
 * Returns `{ error }` rather than throwing: the caller's job is to toast it.
 */
export const runSheetWindow = (day, times) => {
  if (!day || !times?.[0] || !times?.[1]) {
    return { error: 'Pick a day and a time window' };
  }

  const at = (time) => day.hour(time.hour()).minute(time.minute()).second(0).millisecond(0);
  const from = at(times[0]);
  const to = at(times[1]);

  // Equal ends would ask the server for a window with nothing in it. antd
  // already swaps a backwards pair, so this is the only degenerate case left.
  if (!to.isAfter(from)) {
    return { error: 'The window has to end after it starts' };
  }

  return {
    from: from.format('YYYY-MM-DD HH:mm:ss'),
    to: to.format('YYYY-MM-DD HH:mm:ss'),
    filename: `run-sheet-${from.format('YYYYMMDD-HHmm')}-to-${to.format('HHmm')}.xlsx`,
  };
};
